import {
    Chart as ChartJS,
    BarController,
    BarElement,
    LinearScale,
    LogarithmicScale,
    CategoryScale,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { RocketRangeGameInstance } from "src/artifacts/ts/types";

// Register required components for Bar Chart
ChartJS.register(
    BarController,
    BarElement,
    LinearScale,
    LogarithmicScale,
    CategoryScale,
    Tooltip,
    Legend
);

interface RocketRangeBarProps {
    gameData: RocketRangeGameInstance;
}

const RocketRangeBar: React.FC<RocketRangeBarProps> = ({ gameData }) => {

    const bigInt16ToNumber = (a: bigint) => Number((a ?? 0n) / 10n ** 16n) / 100
    gameData.totalPotSize
    const potData = {
        labels: [
            "Down 4%+",
            "Down 1-4%",
            "No Change",
            "Up 1-4%",
            "Up 4%+",
        ],
        datasets: [
            {
                label: "Pot Distribution (ALPH)",
                data: [
                    bigInt16ToNumber(gameData.optionOnePotSize),
                    bigInt16ToNumber(gameData.optionTwoPotSize),
                    bigInt16ToNumber(gameData.optionThreePotSize),
                    bigInt16ToNumber(gameData.optionFourPotSize),
                    bigInt16ToNumber(gameData.optionFivePotSize),
                ],
                backgroundColor: [
                    "rgb(239, 68, 68)",
                    "rgb(248, 113, 113)",
                    "rgb(234, 179, 8)",
                    "rgb(74, 222, 128)",
                    "rgb(34, 197, 94)",
                ],
                borderColor: [
                    "rgba(255, 205, 86, 1)",
                    "rgba(54, 162, 235, 1)",
                    "rgba(75, 192, 192, 1)",
                    "rgba(255, 99, 132, 1)",
                    "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 0,
            },
        ],
    };


    const coefficientPlugin = {
        id: "coefficientPlugin",
        afterDatasetsDraw: (chart: any) => {
            const { ctx, chartArea, scales } = chart;
            const dataset = chart.data.datasets[0].data;
            const labels = chart.data.labels;

            dataset.forEach((value: number, index: number) => {
                const ratio = bigInt16ToNumber(gameData.totalPotSize) > 0 ? ((bigInt16ToNumber(gameData.totalPotSize) * 0.92) / value).toFixed(1) : "0.0";
                const barX = scales.x.getPixelForValue(index);
                const barY = scales.y.getPixelForValue(value);

                ctx.save();
                ctx.font = "14px Arial";
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                ctx.textAlign = "center";
                ctx.fillText(`X ${ratio}`, barX, barY + 20);
                ctx.restore();
            });
        },
    };

    return (
        <Bar
            data={potData}
            options={{
                scales: {
                    x: {
                        grid: { color: "rgba(255, 255, 255, 0.1)" },
                        ticks: {
                            color: "rgba(255, 255, 255, 0.7)",
                            font: { size: 12 },
                        },
                    },
                    y: {
                        type: "linear", // Logarithmic scale
                        grid: { color: "rgba(255, 255, 255, 0.1)" },
                        ticks: {
                            color: "rgba(255, 255, 255, 0.7)",
                            callback: (value) => value.toString(),
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                        labels: {
                            color: "rgba(255, 255, 255, 1)",
                            font: { size: 12 },
                        },
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: (context: any) =>
                                `${context.label}: ${context.raw} ALPH`,
                        },
                    },
                },
                maintainAspectRatio: false,
            }}
            style={{ height: 400 }}
            plugins={[coefficientPlugin]}
        />
    );
};

export default RocketRangeBar;